import giftCardLogo from '@/modules/perseo-billing/assets/images/gift-card-logo.png';
import { formatPrice } from '@/modules/perseo-billing/hooks';
import type { IPaymentMethod } from '@/modules/perseo-billing/interfaces/src/bff-web/billing';
import { Typography } from '@/modules/perseo-billing/ui/react/src';

interface IGiftCardPreviewProps {
  paymentMethod: IPaymentMethod;
}

const GiftCardPreview = ({ paymentMethod }: IGiftCardPreviewProps) => {
  const amount = formatPrice(Number(paymentMethod?.amount) ?? 0);
  return (
    <div className="co-w-full co-flex co-flex-col co-gap-8px">
      <img
        src={giftCardLogo}
        alt={'product'}
        width={48}
        height={48}
        className="co-absolute co-top-0 co-left-8"
        aria-label={paymentMethod?.type}
      />
      <div className="co-flex co-justify-end co-self-end co-w-2/3">
        <Typography align="right">{paymentMethod?.cardNumber}</Typography>
      </div>
      <div className="co-w-2/3 co-flex co-py-2px co-px-8px co-justify-end co-self-end co-bg-white co-rounded-4px">
        <Typography
          weight="semibold"
          align="right"
          className="co-text-[#026933]"
        >
          {amount}
        </Typography>
      </div>
    </div>
  );
};

export default GiftCardPreview;
